// src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import SidebarLayout from './components/SidebarLayout';

import Landing from './pages/Landing';
import Overview from './pages/Overview';
import TradeJournaling from './pages/TradeJournaling';
import RiskCalculator from './pages/RiskCalculator';
import Updates from './pages/Updates';
import TradeAIInsights from './pages/TradeAIInsights';
import BrokerIntegrations from './pages/BrokerIntegrations';
import AdvancedAnalytics from './pages/AdvancedAnalytics';
import StrategyLab from './pages/StrategyLab';
import UsersAdmin from './pages/UsersAdmin';

import AuthProvider, { useAuth } from './auth/AuthContext';

const ADMIN_EMAIL = 'lawilkins13@gmail.com';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();

  const currentEmail = (user?.email || '').toLowerCase();
  const isAdmin = currentEmail === ADMIN_EMAIL;

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <SidebarLayout>
          <Routes>
            <Route
              path="/"
              element={<Landing />}
            />

            <Route
              path="/overview"
              element={<Overview />}
            />

            <Route
              path="/journal"
              element={<TradeJournaling />}
            />

            <Route
              path="/risk-calculator"
              element={<RiskCalculator />}
            />

            <Route
              path="/updates"
              element={<Updates />}
            />

            <Route
              path="/ai-insights"
              element={<TradeAIInsights />}
            />

            <Route
              path="/integrations"
              element={<BrokerIntegrations />}
            />

            <Route
              path="/advanced-analytics"
              element={<AdvancedAnalytics />}
            />

            <Route
              path="/strategy-lab"
              element={<StrategyLab />}
            />

            <Route
              path="/users-admin"
              element={
                <AdminRoute>
                  <UsersAdmin />
                </AdminRoute>
              }
            />
          </Routes>
        </SidebarLayout>
      </Router>
    </AuthProvider>
  );
}

export default App;